import { useState } from "react";
import { cn } from "@/lib/utils";
import { WaitlistTab } from "@/components/gtm/WaitlistTab";
import { ProspectingTab } from "@/components/gtm/ProspectingTab";
import { CrmTab } from "@/components/gtm/CrmTab";

type Tab = "waitlist" | "prospecting" | "crm";

const TABS: { id: Tab; label: string }[] = [
  { id: "waitlist", label: "Waitlist" },
  { id: "prospecting", label: "Prospecting" },
  { id: "crm", label: "CRM" },
];

export function GtmEnginePage() {
  const [tab, setTab] = useState<Tab>("waitlist");

  return (
    <div className="mx-auto max-w-6xl p-8">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold tracking-tight">GTM Engine</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Waitlist, prospecting, and CRM in one place.
        </p>
      </div>

      <div className="mb-6 border-b">
        <div className="flex gap-1">
          {TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              onClick={() => setTab(t.id)}
              className={cn(
                "border-b-2 px-4 py-2 text-sm font-medium transition-colors",
                tab === t.id
                  ? "border-primary text-foreground"
                  : "border-transparent text-muted-foreground hover:text-foreground"
              )}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {tab === "waitlist" && <WaitlistTab />}
      {tab === "prospecting" && <ProspectingTab />}
      {tab === "crm" && <CrmTab />}
    </div>
  );
}
